///<reference path="text-change-strategies/strategy-insert-from-paste.ts"/>
///<reference path="text-change-strategies/strategy-add.ts"/>
///<reference path="text-change-strategies/strategy-backspace.ts"/>
///<reference path="text-change-strategies/strategy-delete.ts"/>

module Meevo.Components.Controls.HideInput {
    export class ActionWrapper {

        get event() {
            return this._event;
        }

        private readonly _event: InputEvent;
        private readonly selectionStart: number;
        private readonly selectionEnd: number;
        private readonly visibilityState: VisibilityState;
        private inputValue: string;
        private actualValue: string;

        constructor(_event: InputEvent, visibilityState: VisibilityState, selectionStart: number, selectionEnd: number) {
            this._event = _event;
            this.inputValue = '';
            this.visibilityState = visibilityState;
            this.selectionStart = selectionStart;
            this.selectionEnd = selectionEnd;
        }

        setValues({inputValue, actualValue}) {
            this.inputValue = inputValue;
            this.actualValue = actualValue;
        }

        processActualValue(): string {
            if (this.visibilityState === VisibilityState.Visible) return this.inputValue;

            let textChangeStrategy: ITextChangeStrategy;

            switch (this.event.inputType) {
                case 'deleteContentBackward':
                    textChangeStrategy = new StrategyBackspace(this.actualValue, this.inputValue, this.event.data);
                    break;
                case 'deleteContentForward':
                    textChangeStrategy = new StrategyDelete(this.actualValue, this.inputValue, this.event.data);
                    break;
                case 'insertFromPaste':
                    textChangeStrategy = new StrategyInsertFromPaste(this.actualValue, this.inputValue, this.event.data);
                    break;
                case 'insertText':
                default:
                    textChangeStrategy = new StrategyAdd(this.actualValue, this.inputValue, this.event.data);
            }

            return textChangeStrategy.getActualValue(this.selectionStart, this.selectionEnd);

        }

    }
}
